.root {
  margin: 0 0 1.25rem;
  padding: 0.85rem 1rem;
  border-radius: 14px;
  background: var(--mantine-color-body, #fff);
  border: 1px solid var(--mantine-color-gray-2, #e2e8f0);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.55rem 0.75rem;
  border-radius: 10px;
  border: 1px solid var(--mantine-color-gray-2, #e2e8f0);
  background: var(--mantine-color-gray-0, #f8fafc);
  color: var(--mantine-color-gray-6, #64748b);
  font-size: 0.875rem;
}

.itemCurrent {
  border-color: #93c5fd;
  background: #eff6ff;
  color: #1e40af;
  font-weight: 600;
}

.itemCompleted {
  border-color: #86efac;
  background: #f0fdf4;
  color: #166534;
}

.index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.08);
  font-size: 0.75rem;
  font-weight: 700;
  flex-shrink: 0;
}

.itemCurrent .index {
  background: #2563eb;
  color: #fff;
}

.itemCompleted .index {
  background: #16a34a;
  color: #fff;
}

.label {
  min-width: 0;
}

@media (max-width: 960px) {
  .list {
    grid-template-columns: 1fr;
  }
}
